/**
 * Pro Upgrade Prompt Dialog
 *
 * A wrapper component that renders the UpgradeDialog when a Pro-required error
 * is encountered from IPC calls. This component should be rendered once at the
 * app level (e.g., in App.tsx) to handle all Pro-required errors globally.
 *
 * The dialog state is managed by the proUpgradePromptStore, which can be
 * triggered from anywhere in the app using useProRequiredHandler or
 * useProUpgradePromptStore.
 */

import { useProUpgradePromptStore } from '../store/proUpgradePromptStore';
import { UpgradeDialog } from './UpgradeDialog';

/**
 * Renders the UpgradeDialog when triggered by a Pro-required error.
 * Should be rendered once at the app level.
 */
export function ProUpgradePromptDialog() {
  const isOpen = useProUpgradePromptStore((s) => s.isOpen);
  const feature = useProUpgradePromptStore((s) => s.feature);
  const hidePrompt = useProUpgradePromptStore((s) => s.hidePrompt);

  return (
    <UpgradeDialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          hidePrompt();
        }
      }}
      feature={feature}
    />
  );
}
